import React from 'react';
import type { ReactElement } from 'react';

import type { GlyphProps } from '@atlaskit/icon/types';
import PageLiveDoc16Icon from '@atlaskit/icon-object/glyph/page-live-doc/16';
import PageLiveDoc24Icon from '@atlaskit/icon-object/glyph/page-live-doc/24';

const iconMap = {
	small: PageLiveDoc16Icon,
	medium: PageLiveDoc24Icon,
};

export type LiveDocsIconTileProps = Pick<GlyphProps, 'label' | 'testId'> & {
	size: 'small' | 'medium';
};

export const LiveDocsIconTile = ({ label, size, testId }: LiveDocsIconTileProps): ReactElement => {
	const IconComponent = iconMap[size];
	return <IconComponent label={label} testId={testId} />;
};
